import React from 'react';
import { cn } from '@/lib/utils';

interface StepPipsProps {
  /** The currently active step (1-based). */
  current: number;
  /** Total number of steps. */
  total: number;
  className?: string;
}

export const StepPips: React.FC<StepPipsProps> = ({ current, total, className }) => (
  <div className={cn('flex items-center justify-center gap-2', className)}>
    {Array.from({ length: total }, (_, i) => {
      const idx = i + 1;
      return (
        <div
          key={idx}
          className={cn(
            'h-1 rounded-full transition-all duration-300',
            idx < current && 'w-6 bg-primary/40',
            idx === current && 'w-8 bg-primary',
            idx > current && 'w-5 bg-muted',
          )}
        />
      );
    })}
  </div>
);

export default StepPips;
